import axios from 'axios'
import {
  CreateInventoryType,
  DeleteInventory,
  InventoryType,
  ReturnInventoryType,
  TransferInventoryType,
} from '../models/inventory'
import {Pagination} from '../models/base'
const Endpoint = '/api/devicesinventory'

export const getAllInventory = async (query: string = '') => {
  const res = await axios.get(Endpoint + '?' + query)
  return res.data.data as Pagination<InventoryType[]>
}

export const addInventory = async (data: CreateInventoryType) => {
  const res = await axios.post(Endpoint + '/batch', data)
  return res.data
}

export const transferInventory = async (data: TransferInventoryType | ReturnInventoryType) => {
  const res = await axios.put(Endpoint + '/batch', data)
  return res.data
}

export const deleteInventory = async (data: DeleteInventory) => {
  const res = await axios.delete(Endpoint + '/selection' , {data})
  return res.data
}